import { Grid } from '@mui/material'
import { styled } from '@mui/material/styles'

type StyledButtonsContainerProps = {
  sticky?: boolean
}

export const StyledFormbuilderButtonsContainer = styled(Grid, {
  shouldForwardProp: prop => prop !== 'sticky',
})<StyledButtonsContainerProps>(({ sticky }) => {
  return {
    alignItems: 'center',
    display: 'flex',
    gap: 16,
    justifyContent: 'flex-end',
    ...(sticky && {
      bottom: 0,
      paddingBottom: 16,
      position: 'sticky',
    }),
  }
})

export const FormbuilderButtonsContainer = (props: any) => {
  return <StyledFormbuilderButtonsContainer {...props} size={12} />
}
